// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-container-mVMXJ {\n  display: inline-block;\n  margin-bottom: 15px;\n  position: relative;\n  width: 615px;\n}\n.inputContainer-pVsFt {\n  display: flex;\n  justify-content: space-between;\n  border: 2px solid #ececec;\n  border-radius: 4px;\n  overflow: hidden;\n  height: 50px;\n}\n.inputContainer-pVsFt.search-focused-HMfgX {\n  border-color: #287ec7;\n}\n.search-input-nGlYh {\n  border: none;\n  padding-left: 15px;\n  height: 50px;\n  width: calc(100% - 50px);\n}\n.search-input-nGlYh::placeholder {\n  color: #999999;\n}\n.open-dialog-button-geQnL {\n  border: 0;\n  font-size: 16px;\n  margin-right: 8px;\n  height: 46px;\n  padding-left: 0;\n}\n.open-dialog-button-geQnL:hover {\n  cursor: pointer;\n}\n.open-dialog-button-geQnL:before {\n  font-size: 14px;\n}\nbutton.open-dialog-button-geQnL:active {\n  box-shadow: none;\n  border: none;\n}\nbutton.reset-button-e\\+lat {\n  border: 0;\n  height: 30px;\n  width: 30px;\n  border-radius: 50%;\n  padding: 8px;\n  margin-top: 8px;\n  margin-right: 5px;\n}\nbutton.reset-button-e\\+lat:before {\n  font-size: 14px;\n}\nbutton.reset-button-e\\+lat:hover, button.reset-button-e\\+lat:active {\n  background-color: #eeeeee;\n  box-shadow: none;\n  border: none;\n  cursor: pointer;\n}\n.search-Lo-nX {\n  border-radius: 0 4px 4px 0;\n  border: 2px solid #008859;\n  border-left: 0;\n  vertical-align: bottom;\n  padding: 0 17px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  height: 50px;\n}\nbutton.search-Lo-nX.search-focused-HMfgX, button.search-Lo-nX.search-focused-HMfgX:hover {\n  border: 2px solid #287ec7;\n  border-left: 0;\n}\n.searchIcon-vbdF8 {\n  font-size: 20px !important;\n}\n.smallSearch-qIMGg.search-container-mVMXJ {\n  width: 415px;\n  margin-right: 40px;\n}\n.smallSearch-qIMGg .inputContainer-pVsFt {\n  height: 40px;\n}\n.smallSearch-qIMGg .search-Lo-nX {\n  height: 40px;\n  padding: 8px 10px;\n  right: -39px;\n}\n.smallSearch-qIMGg .search-input-nGlYh {\n  height: 38px;\n}\n.smallSearch-qIMGg .open-dialog-button-geQnL {\n  height: 36px;\n}\n.smallSearch-qIMGg button.reset-button-e\\+lat {\n  margin-top: 3px;\n}\n", "",{"version":3,"sources":["webpack://./app/EAssessment.UI.Common/app-components/search/index.less"],"names":[],"mappings":"AAEA;EAEI,qBAAA;EACA,mBAAA;EACA,kBAAA;EAEA,YAAA;AA6GJ;AAnHA;EASI,aAAA;EACA,8BAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AA6GJ;AA3GI;EACE,qBAAA;AA6GN;AA9HA;EAqBI,YAAA;EACA,kBAAA;EAEA,YAAA;EACA,wBAAA;AA2GJ;AAzGI;EACE,cAAA;AA2GN;AAvIA;EAgCI,SAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;AA0GJ;AAxGI;EACE,eAAA;AA0GN;AAvGI;EACE,eAAA;AAyGN;AApJA;EAgDI,gBAAA;EACA,YAAA;AAuGJ;AAxJA;EAqDI,SAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AAsGJ;AApGI;EACE,eAAA;AAsGN;AApGI;EAEE,yBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AAsGN;AA3KA;EA0EI,0BAAA;EACA,yBAAA;EACA,cAAA;EACA,sBAAA;EAEA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EAEA,YAAA;AAkGJ;AAtLA;EAwFI,yBAAA;EACA,cAAA;AAkGJ;AA3LA;EA6FI,0BAAA;AAiGJ;AA7FI;EACE,YAAA;EACA,kBAAA;AA+FN;AAlMA;EAsGM,YAAA;AA+FN;AArMA;EAyGM,YAAA;EACA,iBAAA;EACA,YAAA;AA+FN;AA1MA;EA8GM,YAAA;AA+FN;AA7MA;EAiHM,YAAA;AA+FN;AAhNA;EAqHM,eAAA;AA8FN","sourcesContent":["@import '@cirrus/legacy/app-components/app/styles/colors/colors-default.less';\n\n:local {\n  .search-container {\n    display: inline-block;\n    margin-bottom: 15px;\n    position: relative;\n\n    width: 615px;\n  }\n  .inputContainer {\n    display: flex;\n    justify-content: space-between;\n    border: 2px solid @clr-gray-100;\n    border-radius: 4px;\n    overflow: hidden;\n    height: 50px;\n\n    &.search-focused {\n      border-color: @clr-blue-210;\n    }\n  }\n  .search-input {\n    border: none;\n    padding-left: 15px;\n\n    height: 50px;\n    width: calc(~'100% - 50px');\n\n    &::placeholder {\n      color: @clr-gray-280;\n    }\n  }\n  .open-dialog-button {\n    border: 0;\n    font-size: 16px;\n    margin-right: 8px;\n    height: 46px;\n    padding-left: 0;\n\n    &:hover {\n      cursor: pointer;\n    }\n\n    &:before {\n      font-size: 14px;\n    }\n  }\n\n  button.open-dialog-button:active {\n    box-shadow: none;\n    border: none;\n  }\n\n  button.reset-button {\n    border: 0;\n    height: 30px;\n    width: 30px;\n    border-radius: 50%;\n    padding: 8px;\n    margin-top: 8px;\n    margin-right: 5px;\n\n    &:before {\n      font-size: 14px;\n    }\n    &:hover,\n    &:active {\n      background-color: @clr-gray-80;\n      box-shadow: none;\n      border: none;\n      cursor: pointer;\n    }\n  }\n\n  .search {\n    border-radius: 0 4px 4px 0;\n    border: 2px solid @clr-green-300;\n    border-left: 0;\n    vertical-align: bottom;\n\n    padding: 0 17px;\n    position: absolute;\n    right: 0;\n    top: 0;\n\n    height: 50px;\n  }\n  button.search.search-focused,\n  button.search.search-focused:hover {\n    border: 2px solid @clr-blue-210;\n    border-left: 0;\n  }\n\n  .searchIcon {\n    font-size: 20px !important;\n  }\n\n  .smallSearch {\n    &.search-container {\n      width: 415px;\n      margin-right: 40px;\n    }\n    .inputContainer {\n      height: 40px;\n    }\n    .search {\n      height: 40px;\n      padding: 8px 10px;\n      right: -39px;\n    }\n    .search-input {\n      height: 38px;\n    }\n    .open-dialog-button {\n      height: 36px;\n    }\n\n    button.reset-button {\n      margin-top: 3px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"white": "#fff",
	"black": "#000",
	"yellow": "#008859",
	"yellowinprogress": "#BEA66E",
	"blackt30": "rgba(0, 0, 0, 0.3)",
	"black50": "rgba(0, 0, 0, 0.75)",
	"blue100": "#4690d1",
	"blue120": "#2791c6",
	"blue130": "#2196f3",
	"blue150": "#add2f7",
	"blue210": "#287ec7",
	"blue300": "#0478c6",
	"blue400": "#024b7b",
	"blue330": "#0055b0",
	"brown310": "#7f707d",
	"red": "red",
	"red70": "#f7bfb9",
	"red100": "#e87d7d",
	"red300": "#f35958",
	"red320": "#e05251",
	"red405": "#a94442",
	"red410": "#bc2b43",
	"red500": "#cc2d30",
	"red550": "#c60000",
	"red900": "#ff0000",
	"red905": "#cf4444",
	"red910": "#c60000",
	"green200": "#d8f0ea",
	"green210": "#c0e8dc",
	"green250": "#09998d",
	"green270": "#47bcb3",
	"green300": "#008859",
	"green310": "#4cb992",
	"green505": "#119264",
	"green520": "#00794f",
	"green650": "#b1dac6",
	"green700": "#008000",
	"green710": "#30b382",
	"green800": "#008859",
	"yellow90": "#fbdba0",
	"yellow410": "#fedb97",
	"orange200": "#eda04f",
	"orange300": "#ee9a02",
	"orange350": "#e7a257",
	"orange360": "#c3a565",
	"orange380": "#ff8c40",
	"orange400": "#ef7400",
	"orange420": "#ff6600",
	"orange550": "#bf5000",
	"blue170": "#7e9fc2",
	"blue220": "#537fad",
	"blue250": "#2879c7",
	"darkBlue400": "#272c40",
	"blue305": "#0055b0",
	"blue310": "#00829b",
	"brown320": "#7f707d",
	"gray75": "#f6f6f6",
	"gray80": "#eeeeee",
	"gray85": "#ecedec",
	"gray95": "#d9d9d9",
	"gray120": "#e5e9ec",
	"gray200": "#dddddd",
	"gray201": "#f2f2f2",
	"gray214": "#c4c4c4",
	"gray215": "#cccccc",
	"gray220": "#ccd0d3",
	"gray225": "#c1c9cd",
	"gray240": "#cfcfcf",
	"gray230": "#d9edf7",
	"gray245": "#8b8b8b",
	"gray250": "#808080",
	"gray320": "#dedce0",
	"gray400": "#5e5e5e",
	"gray420": "#555555",
	"gray850": "#554854",
	"gray305": "#757575",
	"gray500": "#333333",
	"gray800": "#4a4a4a",
	"gray820": "#40465d",
	"gray855": "#8b91a0",
	"gray280": "#999999",
	"gray50": "#f9f9f9",
	"gray100": "#ececec",
	"gray125": "#e4e4e4",
	"gray235": "#c1bebe",
	"gray350": "#6b546a",
	"gray600": "#f1f1f1",
	"gray720": "#b6b6b6",
	"gray740": "#b6a8b4",
	"gray755": "#ebebeb",
	"gray810": "#525252",
	"gray860": "#9b9b9b",
	"gray870": "#929292",
	"gray890": "#756372",
	"gray895": "#989898",
	"gray910": "#444059",
	"gray925": "#9c9c9c",
	"gray930": "#ddcfac",
	"gray935": "#5f6368",
	"gray920": "#757575",
	"gray950": "#ece4d0",
	"gray1000": "#ebe8e8",
	"gray1010": "#e6e6e6",
	"gray1050": "#e0e6f0",
	"gray1060": "#c6c6c6",
	"gray1100": "#ededed",
	"gray1120": "#8e818c",
	"gray1150": "#212121",
	"purple": "#6a546a",
	"transparent": "transparent",
	"searchContainer": "search-container-mVMXJ",
	"inputContainer": "inputContainer-pVsFt",
	"searchFocused": "search-focused-HMfgX",
	"searchInput": "search-input-nGlYh",
	"openDialogButton": "open-dialog-button-geQnL",
	"resetButton": "reset-button-e+lat",
	"search": "search-Lo-nX",
	"searchIcon": "searchIcon-vbdF8",
	"smallSearch": "smallSearch-qIMGg"
};
export default ___CSS_LOADER_EXPORT___;
